import { render, staticRenderFns } from "./DashboardSale.vue?vue&type=template&id=62d5622e&"
import script from "./DashboardSale.vue?vue&type=script&lang=ts&"
export * from "./DashboardSale.vue?vue&type=script&lang=ts&"
import style0 from "./DashboardSale.vue?vue&type=style&index=0&id=62d5622e&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports